import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const Table = (props) => {
  const { path, head, body, pagination, paginationdata } = props;
  console.log("Table Props:", props);

  const navigate = useNavigate();

  const redirect = (path) => {
    if (path) {
      navigate(path);
    }
  };

  let show = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
  ];

  const handleNext = () => {
    let currentPage = parseInt(pagination?.currentPage) + 1;

    if (currentPage <= parseInt(pagination?.totalPages)) {
      let data = {
        ...pagination,
        currentPage: currentPage,
      };

      paginationdata(data);
    }
  };

  const handlePrevious = () => {
    let currentPage = parseInt(pagination?.currentPage) - 1;

    if (currentPage > 0) {
      let data = {
        ...pagination,
        currentPage: currentPage,
      };

      paginationdata(data);
    }
  };

  return (
    <div className="w-full bg-white rounded-md overflow-hidden flex flex-col">
      <div
        style={{
          maxHeight: "70vh",
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="flex-1 hide-scrollbar"
      >
        <table className="w-full min-w-full">
          {head?.length > 0 && (
            <thead>
              <tr className="border-b">
                {head?.map((value, index) => {
                  return (
                    <td
                      className={
                        index === head?.length - 1
                          ? "p-4 text-gray-500 text-center sticky top-0 bg-white z-10"
                          : value?.class
                          ? value?.class + " sticky top-0 bg-white z-10"
                          : "p-4 text-gray-500 sticky top-0 bg-white z-10"
                      }
                      style={{ position: "sticky", top: 0 }}
                    >
                      {value?.name}
                    </td>
                  );
                })}
              </tr>
            </thead>
          )}
          {body?.length > 0 && (
            <tbody>
              {body?.map((value, index) => {
                return (
                  <tr
                    className={
                      path
                        ? "border-b hover:bg-gray-100 cursor-pointer"
                        : "border-b hover:bg-gray-100"
                    }
                    onClick={() => redirect(value?.path)}
                  >
                    {head?.map((val, ind) => {
                      return Object?.keys(value)?.includes(val?.name) ? (
                        <td
                          className={
                            ind === head?.length - 1
                              ? "p-4 text-center"
                              : val?.className
                              ? val?.className
                              : "p-4"
                          }
                        >
                          {value?.[val?.name] ? value?.[val?.name] : "-"}
                        </td>
                      ) : (
                        <td className="p-4">-</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          )}

          {/* {body?.length > 0 && (
        <tfoot className="">
          <tr>
            <td colSpan={head?.length} className="p-4">
              <div className="flex justify-between text-gray-500">
                <div>
                  <span className="pr-3">Show</span>
                  <Select
                    className="w-20 text-regular"
                    value={10}
                    options={show}
                  />
                  <span className="pl-5">1 - 10 of 100 Items</span>
                </div>
                <div>
                  <span>
                    <Button className="px-2">
                      <div className="text-center text-xs text-gray-600">
                        <LeftOutlined />
                      </div>
                    </Button>
                  </span>
                  <span className="px-3">1 out of 10</span>
                  <span>
                    <Button className="px-2">
                      <div className="text-center text-xs text-gray-600">
                        <RightOutlined />
                      </div>
                    </Button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      )} */}
        </table>
      </div>
      {/* foot */}
      {pagination?.currentPage ? (
        <div className="border-t p-4 bg-white">
          <div className="flex justify-between items-center text-gray-600 text-sm font-medium w-full">
            <div className="flex items-center">
              <span className="pr-3">TOTAL</span>
              <span>
                {pagination?.currentPage > 1
                  ? (pagination?.currentPage - 1) * 10 + 1
                  : 1}{" "}
                -{" "}
                {Math.min(pagination?.currentPage * 10, pagination?.totalCount)}
                &nbsp;OF&nbsp;{pagination?.totalCount}
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <button
                type="button"
                className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be] flex items-center justify-center"
                onClick={handlePrevious}
              >
                <LeftOutlined className="text-xs" />
              </button>
              <span>
                {pagination?.currentPage} OUT OF {pagination?.totalPages}
              </span>
              <button
                className="px-4 py-1 rounded-md border-2 border-gray-300 hover:border-[#6254be] flex items-center justify-center"
                onClick={handleNext}
              >
                <RightOutlined className="text-xs" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Table;
